import { fmtTimeCT, fmtDateCT } from "@/lib/api";

export function StatusPill({ event }) {
  const st = event?.status?.state;
  if (st === "in") {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-sm bg-liversed/15 px-2 py-0.5 font-score text-[10px] font-bold text-liversed">
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-liversed" />
        {event.status?.detail || "LIVE"}
      </span>
    );
  }
  if (st === "post") {
    return <span className="rounded-sm bg-slate-700/40 px-2 py-0.5 font-score text-[10px] text-slate-400">FINAL</span>;
  }
  return (
    <span className="rounded-sm bg-bcast/15 px-2 py-0.5 font-score text-[10px] text-bcast">
      {fmtDateCT(event?.date, false)} · {fmtTimeCT(event?.date)} CT
    </span>
  );
}

export function MatchupRows({ event, compact = false }) {
  if (!event) return <p className="py-2 font-score text-xs text-slate-600">No game data</p>;
  const row = (side) => (
    <div className="flex items-center justify-between gap-2">
      <span className={`truncate font-body ${side.winner ? "font-bold text-white" : "text-slate-300"} ${compact ? "text-xs" : "text-sm"}`}>
        {side.logo && <img src={side.logo} alt="" className="mr-1.5 inline h-5 w-5 object-contain" />}
        {side.abbr || side.name}
      </span>
      <span className={`font-score ${compact ? "text-sm" : "text-lg"} ${side.winner ? "text-volt" : "text-slate-200"}`}>{side.score}</span>
    </div>
  );
  return (
    <div className="space-y-1">
      {row(event.away)}
      {row(event.home)}
    </div>
  );
}
